<template>
  <ion-header :translucent="true">
    <ion-toolbar>
      <ion-buttons slot="secondary">
        <ion-button @click="closeModal">
          <ion-icon slot="icon-only" :icon="closeOutline"></ion-icon>
        </ion-button>
      </ion-buttons>
      <ion-title>{{ title }}</ion-title>
    </ion-toolbar>
  </ion-header>
  <ion-content fullscreen>
    <ion-list>
      <ion-item v-if="usergroup == ''">
        <ion-thumbnail style="--size: 44px; --border-radius: 50%;" slot="start">
          <img @error="imgUrlAlt" v-if="profilePic != '' && profilePic != undefined" :src="profilepath + profilePic">
          <img src="/assets/spyguy.png" v-if="profilePic == '' || profilePic == undefined">
        </ion-thumbnail>
        <ion-label v-if="this.$store.state.profile.fullname != ''">
          <h2>{{ this.$store.state.profile.fullname }}</h2>
          <p>@{{ this.$store.state.profile.username }}</p>
        </ion-label>
        <ion-label v-else>
          <h2>@{{ this.$store.state.profile.username }}</h2>
        </ion-label>
        <ion-chip v-if="!report" slot="end" @click="openFriendModal">
          <ion-icon style="font-size:14px;" :icon="showVisibility(1)"></ion-icon>
          <ion-label><strong>{{ showVisibility(0) }}</strong></ion-label>
          <ion-icon style="font-size:14px;" :icon="caretDown"></ion-icon>
        </ion-chip>
      </ion-item>
      <ion-item v-else>
        <ion-thumbnail style="--size: 44px; --border-radius: 50%;" slot="start">
          <img @error="imgUrlAlt" v-if="usergroup.profile_image != '' && usergroup.profile_image != undefined"
            :src="profilepath + usergroup.profile_image">
          <img src="/assets/spyguy.png" v-if="usergroup.profile_image == '' || usergroup.profile_image == undefined">
        </ion-thumbnail>
        <ion-label>
          <h2>{{ usergroup.name }}</h2>
          <p>Posting as {{ profileName }}</p>
        </ion-label>
      </ion-item>
      <ion-item>
        <ion-textarea id="caption" class="post-box" @ionInput="saveText" v-model="captionInput"
          :placeholder="placeholderDisplay()" spellcheck rows="4"></ion-textarea>
      </ion-item>
    </ion-list>
    <ion-list v-if="userSuggest" style="max-height: 110px; overflow: scroll;">
      <ion-item button v-for="(userdata, itemIndex) in usernames" :key="itemIndex"
        @click="updateUsername(userdata.username)">
        <img class="post-profile-pic" placeholder="/assets/SuperLikes/like_icon.png"
          v-if="userdata.profile_pic != '' && userdata.profile_pic != undefined"
          :src="profilepath + userdata.profile_pic">
        <img class="post-profile-pic" src="/assets/spyguy.png"
          v-if="userdata.profile_pic == '' || userdata.profile_pic == undefined">
        <ion-label>{{ userdata.username }}
          <p>{{ userdata.name }}</p>
        </ion-label>
      </ion-item>
    </ion-list>
    <ion-list v-if="hashtagSuggest" style="max-height: 110px; overflow: scroll;">
      <ion-item button v-for="(hashtag, itemIndex) in hashtags" :key="itemIndex" @click="updateHashtag(hashtag)">
        <ion-label><strong>{{ hashtag }}</strong></ion-label>
      </ion-item>
    </ion-list>
    <div v-if="loadingLink && linkPreviews == undefined" class="url-block" style="margin-bottom: 2%; cursor:auto;">
      <div style="margin:5px; display:block; width:100%; height: 30px; text-align:center;">
        <ion-spinner></ion-spinner>
      </div>
      <div style="margin-bottom:10px; text-align:center;">{{ $t('loadmessage.links') }}</div>
    </div>
    <div v-if="linkPreviews != undefined">
      <ion-grid class="ion-no-padding url-block">
        <ion-row class="ion-align-items-center">
          <ion-col class="ion-no-padding" size="2"
            v-if="linkPreviews.link_image != '' && linkPreviews.link_image != null">
            <img class="link_image cover" :src="linkPreviews.link_image">
          </ion-col>
          <ion-col>
            <div class="link">{{ getHostName(linkPreviews.link_url) }}</div>
            <div class="link_text" v-show="linkPreviews.link_text != '' || linkPreviews.link_text != undefined">{{
              linkPreviews.link_text }}</div>
          </ion-col>
          <ion-col size="small">
            <div @click="removeLink" class="remove-link"><ion-icon :icon="close"></ion-icon></div>
            <div @click="retryLink" class="remove-link"><ion-icon :icon="refresh"></ion-icon></div>
          </ion-col>
        </ion-row>
      </ion-grid>
    </div>
    <div style="padding:5px 15px;" v-if="photoFiles.length > 0 && showSlides">
      <swiper-container v-if="photoFiles.length > 0 && showSlides" @swiperslidechange="updateTextBox()"
        :pagination="{ clickable: true, dynamicBullets: true }" :navigation="true" :dynamic-bullets="3"
        ref="imageSlider" style="--swiper-navigation-color: rgb(var(--ion-text-color));">
        <swiper-slide v-for="(image, itemIndex) in photoFiles" :key="itemIndex">
          <div style="text-align:center">
            <img v-show="photoType[itemIndex] == 1" style="height:200px;" :src="inputFiles[itemIndex]"
              :id="'image-' + itemIndex">
          </div>
          <div v-show="photoType[itemIndex] == 2" style="background-color:black;">
            <video :src="inputFiles[itemIndex]" :poster="bannerPreview || ''" preload="metadata" controls width="100%" height="200" playsinline></video>
          </div>
        </swiper-slide>
      </swiper-container>
      <div
        style="display:block; margin-top: -44px; margin-left: 5%; margin-right: 5%; width: 90%; position: absolute; z-index: 9999;"
        v-if="photoFiles.length > 0">
        <ion-button fill="clear" style="float:right;" @click="removeItem" color="light">
          <ion-icon color="danger" :icon="trash"></ion-icon>
        </ion-button>
      </div>
    </div>
    <div class="horizontal-scroll-container">
      <div
        class="photo-item"
        v-for="(photo, index) in bannerFiles.length"
        :key="index"
        :class="{ selected: bannerPreview === bannerPreviews[index] }"
        @click="selectBannerPhoto(index)"
      >
        <img style="height:100px; cursor: pointer;" :src="bannerPreviews[index]" alt="Photo" />
      </div>
    </div>
    <div style="padding:0px 15px;">
      <ion-button size="small" @click="goToLiveBroadcast" v-if="this.$store.state.profile.liveEnabled" color="light">
        <ion-icon color="danger" slot="start" :icon="videocam"></ion-icon>
        Live Video
      </ion-button>
      <ion-button size="small" @click="openPicker" color="light">
        <ion-icon color="primary" slot="start" :icon="image"></ion-icon>
        {{ $t("buttons.photovideo") }}
      </ion-button>
      <ion-button size="small" @click="openChooseStoryModal" color="light">
        <ion-icon color="primary" slot="start" :icon="layers"></ion-icon>
        Series
      </ion-button>
      <ion-button size="small" @click="openAddPlaceModal" color="light">
        <ion-icon color="primary" slot="start" :icon="location"></ion-icon>
        Location
      </ion-button>
      <input ref="fileInput" id="file-input" type="file" name="file-input" style="display:none"
        :onchange="handleFileSelection" multiple accept="image/*,video/*" />
    </div>
    <div style="padding:10px 15px;">
      <ion-chip v-if="this.$store.state.post.postData['name'] != ''">
        <ion-icon color="tertiary" :icon="layers"></ion-icon>
        <ion-label>{{ this.$store.state.post.postData['name'] }}</ion-label>
        <ion-icon @click="removeStory" :icon="closeCircle"></ion-icon>
      </ion-chip>
      <ion-chip v-if="(this.$store.state.post.postData['id'] != '' && this.$store.state.post.postData['id'] != null)">
        <ion-icon color="tertiary" :icon="layers"></ion-icon>
        <ion-label v-if="this.$store.state.post.postData['piklist_name']!=''">{{
          this.$store.state.post.postData['piklist_name'] }}</ion-label>
        <ion-label v-else>{{ this.$store.state.post.postData['last_pik_date'] }}</ion-label>
        <ion-icon @click="removeStory" :icon="closeCircle"></ion-icon>
      </ion-chip>
      <ion-chip v-if="this.$store.state.post.postData['location'] != ''">
        <ion-icon color="danger" :icon="location"></ion-icon>
        <ion-label>{{ this.$store.state.post.postData['location'] }}</ion-label>
        <ion-icon @click="removeLocation" :icon="closeCircle"></ion-icon>
      </ion-chip>
    </div>
    <canvas ref="canvasElement" style="display: none;"></canvas>
    <video ref="hiddenVideo" style="display:none;" playsinline></video>
    <ion-list>
      <ion-item v-show="checkForVideo()>0">
        <ion-label>
          <h2>Upload Custom Banner Photo</h2>
        </ion-label>
        <ion-button slot="end" size="small" @click="openBannerPicker" color="light">
          <ion-icon color="primary" slot="start" :icon="image"></ion-icon>
          Banner Photo
        </ion-button>
      </ion-item>
      <ion-item v-show="checkForVideo()>0">
        <ion-label>
          <h2>Set up as premiere</h2> 
        </ion-label>
        <ion-toggle slot="end" @ion-change="setPremiere()" v-model="this.$store.state.post.postData['is_premiere']"></ion-toggle>
      </ion-item>
    </ion-list>
    <input :onchange="handleBannerFileSelection" ref="bannerFileInput" id="file-input" type="file" name="file-input" style="display:none"
         accept="image/*" />
    <p class="ion-padding-horizontal" v-show="this.$store.state.post.postData['is_premiere']">Chose a date and time for your premiere</p>
    <div class="centered-datetime" v-show="this.$store.state.post.postData['is_premiere']">
      <ion-datetime
        v-model="this.$store.state.post.postData['premiere_date']"
        :min="dayjs().tz(dayjs.tz.guess()).format('YYYY-MM-DDTHH:mm')"
        :max="dayjs().tz(dayjs.tz.guess()).add(1, 'year').format('YYYY-MM-DDTHH:mm')" 
        :value="defaultPremiereDate"
        display-format="MMM DD YYYY HH:mm"
        placeholder="Select Date and Time"
        :minute-values="minuteValues">
      </ion-datetime>
    </div>
    <ion-list>
      <ion-item
        v-if="this.$store.state.post.postData['county'] != '' && this.$store.state.post.postData['county'] != null">
        <ion-label>Reporting County<p>{{ this.$store.state.post.postData['county'] }},
            {{ this.$store.state.post.postData['state'] }}</p></ion-label>
      </ion-item>
      <ion-item v-if="fccFail">
        <ion-label>
          <h2>Reporting County</h2>
          <p slot="end">FAILED TO OBTAIN STATE/COUNTY</p>
        </ion-label>
        <ion-button slot="end" color="danger" @click="getStateCounty()">Try Again</ion-button>
      </ion-item>
      <ion-item style="max-height: 110px; overflow:scroll;" v-if="report" lines="none">
        <ion-label class="ion-text-wrap">
          <ion-chip color="primary"><ion-icon
              :icon="checkmarkOutline"></ion-icon><ion-label>#ElectionFraud</ion-label></ion-chip>
          <ion-chip v-for="(hashtagData, hashtagIndex) in hashtagNames" :key="hashtagIndex"
            :color="hashTagsColor(hashtagData)" @click="addHashTag(hashtagData)"><ion-icon
              v-if="checkHashTags(hashtagData)" :icon="checkmarkOutline"></ion-icon><ion-label>#{{ hashtagData
              }}</ion-label></ion-chip>
        </ion-label>
      </ion-item>
      <ion-item v-if="report">
        <ion-button @click="openPopover($event)" fill="clear"><ion-icon slot="start"
            :icon="helpCircleOutline"></ion-icon>Hashtag Definitions</ion-button>
        <ion-popover :is-open="popoverOpen" :event="event" @didDismiss="popoverOpen = false">
          <ion-content class="ion-padding">
            <p v-for="(hashtagInfo, hashtagIndex) in showHashtagInfo" :key="hashtagIndex"><strong>#{{ hashtagIndex
                }}</strong>
              {{ hashtagInfo }}</p>
          </ion-content>
        </ion-popover>
      </ion-item>
    </ion-list>
    </ion-content>
    <ion-button id="post-now" v-show="uploading == false" expand="full" @click="postNewStory">{{ showPostButton()
      }}</ion-button>
    <ion-button v-show="uploading == true" expand="full">{{ uploadingText }}{{ uploadingPercent }}</ion-button>
    <ion-progress-bar v-show="uploading == true" color="primary" :value="uploadingProgress"></ion-progress-bar>
    
</template>

<script>
import { IonContent, IonHeader, IonTitle, IonPopover, IonToolbar, IonButton, IonButtons, IonIcon, IonTextarea, modalController, IonLabel, IonItem, IonList, IonGrid, IonRow, IonCol, IonChip, loadingController, IonProgressBar, alertController, isPlatform, IonSpinner, IonThumbnail, IonDatetime, IonToggle } from '@ionic/vue';
import { closeOutline, refresh, close, image, people, addCircle, trash, helpCircleOutline, checkmarkOutline, reorderFour, playCircle, chevronBackOutline, chevronForwardOutline, caretDown, globe, person, closeCircle, bookmarks, lockClosed, peopleCircle, location, layers, videocam, arrowBackOutline } from 'ionicons/icons';
import { defineComponent, defineAsyncComponent } from 'vue';
import getEnv from '@/utils/env'
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';

// Extend day.js with plugins
dayjs.extend(utc);
dayjs.extend(timezone);

const ChooseStoryModal = defineAsyncComponent(() =>
  import('@/components/ChooseStoryModal.vue'))

const FriendModal = defineAsyncComponent(() =>
  import('@/components/ChooseFriendsModal.vue'))

const VideoPlayerModal = defineAsyncComponent(() =>
  import('@/components/VideoPlayerModal.vue'))

const AddPlaceModal = defineAsyncComponent(() =>
  import('@/components/posts/AddPlace.vue'))

import { Insomnia } from '@awesome-cordova-plugins/insomnia';
import { addLinksToText, checkForUsers, getHostName, checkForHashtags, checkForLinks } from '@/composables/text';


export default defineComponent({
  name: 'CreatePost',
  props: {
    title: { type: String, default: '' },
    share_link: { type: String, default: '' },
    report: { type: Boolean, default: false },
    postgroup: { type: Object, default: null }
  },
  components: { IonContent, IonHeader, IonTitle, IonPopover, IonToolbar, IonButton, IonButtons, IonIcon, IonTextarea, IonLabel, IonItem, IonList, IonGrid, IonRow, IonCol, IonChip, IonProgressBar, IonSpinner, IonThumbnail, IonDatetime, IonToggle},
  setup() {
    const closeModal = () => {
      // Dismiss the modal
      modalController.dismiss(null, 'canceled');
    };

    /* const slideOpts = {
      initialSlide: 0,
      speed: 400,
      clickable: true,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      pagination: {
        el: '.swiper-pagination',
        type: 'fraction',
      },
    }; */

    return {
      closeOutline,
      closeModal,
      image,
      people,
      addCircle,
      trash,
      reorderFour,
      playCircle,
      chevronBackOutline,
      chevronForwardOutline,
      caretDown,
      globe,
      person,
      closeCircle,
      bookmarks,
      lockClosed,
      checkmarkOutline,
      helpCircleOutline,
      addLinksToText,
      getHostName,
      refresh,
      close,
      peopleCircle,
      location,
      layers,
      videocam,
      arrowBackOutline,
      dayjs
    }
  },
  data() {
    return {
      photoFiles: [],
      photoType: [],
      photoCaption: [],
      fileSize: [],
      inputFiles: [],
      showSlides: false,
      sliderIndex: 0,
      userSuggest: false,
      hashtagSuggest: false,
      showLinkBox: false,
      captionInput: '',
      profilepath: getEnv('AWS_URL') + getEnv('PHOTO_BUCKET') + '/profile/',
      loadingIndicator: '',
      largeReader: [],
      slice_size: 1000 * 1024,
      uploading: false,
      uploadingText: '',
      uploadingPercent: '',
      uploadingProgress: 0,
      filesUploaded: 0,
      loadingLink: false,
      popoverOpen: false,
      event: null,
      reporterHashTags: [],
      hashtagNames: ['MachinesOnline','MachinesDown','ViolationofLaw','BallotsVoteTally','VoterRolls',
      'BallotTrafficking', 'VotingSystems','PollBooks','ChainofCustody','VoterHistory',
      'Certification','Racketeering','Obstruction','DestructionofRecords',
      'DropBoxes','SpecialVotingCenters','FinancialTransactions','ViolationofProcedures'],
      //chosenState: 'Choose State',
      retryLinkGrab: false,
      error: '',
      fccFail: false,
      bannerFiles: [],
      bannerPreviews: [],
      bannerFile: null,
      bannerPreview: null,
    }
  },
  async mounted() {
    // console.log('scroll: '+ this.isDisabled);
    //console.log('start post');
    if (this.share_link != '') {
      this.captionInput = this.share_link;
      this.retryLink()
    }
    this.resetPostData();
    if(this.postgroup!=null){
      this.$store.state.post.postData['viewGroup'] = this.postgroup;
    }
    
    if(this.report){
      // get the past US state and location if available
      this.getStateCounty();
    }
    //console.log(this.$store.state.post.postData);
  },
  methods: {
    async goToLiveBroadcast() {
      await modalController.dismiss(null, 'goLive');
    },
    handleBannerFileSelection(event) {
      const files = Array.from(event.target.files);

      // Clear the file input to allow re-selection of the same file(s)
      event.target.value = null;

      // Process each selected file
      this.bannerFile = files.find(file => file.type.startsWith("image/")) || null;
      this.bannerPreview = URL.createObjectURL(this.bannerFile);

      this.bannerFiles.push(this.bannerFile);
      this.bannerPreviews.push(this.bannerPreview);
    },
    handleFileSelection(event) {
      const files = Array.from(event.target.files);
      this.bannerFiles = [];
      this.bannerPreviews = [];
      this.bannerFile = null;
      this.bannerPreview = null;

      // Clear the file input to allow re-selection of the same file(s)
      event.target.value = null;
      let count = 0;
      files.forEach((file) => {
        if (file.type.startsWith("image/")) {
          // Handle photo selection
          const preview = URL.createObjectURL(file);
          this.photoType[count] = 1;
          this.photoCaption[count] = '';
          this.fileSize[count] = file.size;
          this.inputFiles[count] = preview;
          this.photoFiles[count] = () => file;
          count = count + 1;
          
        } else if (file.type.startsWith("video/")) {
          // if there is a video selected it must be the only thing uploaded
          if (files.length>1) {
            this.presentTooManyVideos()
            return;
          }
          // Handle video selection (replace any existing video)
          this.photoType = [];
          this.photoCaption = [];
          this.fileSize = [];
          this.inputFiles = [];
          this.photoFiles = [];
          
          const preview = URL.createObjectURL(file);
          //let url = window.URL.createObjectURL(videoBlob);
          this.photoType[count] = 2;
          this.photoCaption[count] = '';
          this.fileSize[count] =  file.size;
          this.inputFiles[count] = preview;
          this.photoFiles[count] = () => file;
          count = count + 1;
          
          // Extract frames at specific timestamps
          this.grabFramesFromVideo(count - 1);
        }
      });
      this.finishedLoading();
    },
    finishedLoading() {
      if (this.photoFiles.length === this.photoType.length) {
        setTimeout(() => {
          this.showSlides = true;
        }, 500);
      }
    },
    async openPicker() {
      this.$refs['fileInput'].click();
    },
    async openBannerPicker() {
      this.$refs['bannerFileInput'].click();
    },
    async grabFramesFromVideo(itemIndex) {
      const videoElement = this.$refs.hiddenVideo; // Use the hidden video element
      const canvasElement = this.$refs.canvasElement;
      const context = canvasElement.getContext("2d");

      if (!videoElement) {
        console.error('Hidden video element not found.');
        return;
      }

      console.log('Using hidden video element for frame extraction.');

      // Add error handling for video loading
      videoElement.addEventListener('error', (e) => {
        console.error('Error loading video:', e);
      });

      // Wait for the video metadata to load
      videoElement.addEventListener('loadedmetadata', async () => {
        console.log('Video metadata loaded.');
        console.log('Video duration:', videoElement.duration, 'seconds');
        console.log('Video dimensions:', videoElement.videoWidth, videoElement.videoHeight);

        // Set the canvas size to match the video dimensions
        canvasElement.width = videoElement.videoWidth;
        canvasElement.height = videoElement.videoHeight;

        // Generate random timestamps based on the video's duration
        const duration = videoElement.duration;
        const timestamps = [5]; // Always include the 5-second mark
        for (let i = 0; i < 4; i++) {
          const randomTime = Math.random() * duration; // Generate a random time within the video's duration
          timestamps.push(Math.min(randomTime, duration - 1)); // Ensure the timestamp is within bounds
        }
        console.log('Generated timestamps:', timestamps);

        // Extract frames at the generated timestamps
        for (const time of timestamps) {
          await this.extractFrameAtTime(videoElement, canvasElement, context, time);
        }
        this.bannerFile = this.bannerFiles[0];
        this.bannerPreview = this.bannerPreviews[0];
        // Clean up the video URL to release memory
        URL.revokeObjectURL(videoElement.src);
      });

      // Set the video source and start loading
      const hiddenVideoSrc = URL.createObjectURL(this.photoFiles[itemIndex]());
      videoElement.src = hiddenVideoSrc; // Set the hidden video source
      videoElement.load();
    },
    async extractFrameAtTime(videoElement, canvasElement, context, timeInSeconds) {
      return new Promise((resolve) => {
        // Seek to the specified time in the video
        videoElement.currentTime = timeInSeconds;

        // Wait for the seek operation to complete
        videoElement.onseeked = () => {
          console.log(`Seek operation completed at ${timeInSeconds} seconds.`);

          // Draw the current frame onto the canvas
          context.drawImage(videoElement, 0, 0, canvasElement.width, canvasElement.height);

          // Convert the canvas to a data URL
          const dataUrl = canvasElement.toDataURL("image/jpeg");

          // Convert the data URL to a Blob
          const blob = this.dataURLToBlob(dataUrl);

          // Convert the Blob to a File (optional, if you need a File object)
          const file = new File([blob], `frame-${timeInSeconds}.jpg`, { type: "image/jpeg" });

          // Add the frame to the banner previews and files
          this.bannerPreviews.push(dataUrl); // For display
          this.bannerFiles.push(file); // For uploading

          resolve();
        };
      });
    },
    selectBannerPhoto(index) {
      // Set the selected photo as the banner photo
      this.bannerFile = this.bannerFiles[index];
      this.bannerPreview = this.bannerPreviews[index];
      //console.log(`Selected banner photo at index ${index}:`);
      //console.log('Banner file:', this.bannerPreview);
    },
    async removeItem() {
      this.bannerFiles = [];
      this.bannerPreviews = [];
      this.bannerFile = null;
      this.bannerPreview = null;
      
      var slider = await this.$refs['imageSlider'].swiper;
      // if(slider!=null) console.log('got something here');
      let currentIndex = slider.activeIndex;
      URL.revokeObjectURL(this.inputFiles[currentIndex]);
      //let currentIndex = await slider.getActiveIndex();
     
      this.showSlides = false;
      this.captionInput = '';
      this.photoFiles.splice(currentIndex, 1);
      this.inputFiles.splice(currentIndex, 1);
      this.photoType.splice(currentIndex, 1);
      this.photoCaption.splice(currentIndex, 1);
      this.fileSize.splice(currentIndex, 1);
      setTimeout(async () => {
        if (this.photoFiles.length > 0) {
          this.captionInput = this.photoCaption[0];
          this.showSlides = true;
        }
      }, 500);
    },
    retryLink() {
      this.removeLink();
      this.$store.commit('helpers/setLinkUrl', { retryLink: true });
      this.saveText();
    },
    async saveText() {
      if (this.showSlides) { // multi-photo post
        var slider = await this.$refs['imageSlider'].swiper;
        let currentIndex = slider.activeIndex;
        //let currentIndex = await slider.getActiveIndex();
        this.sliderIndex = currentIndex;
        let textInfo = this.captionInput;
        this.hashtagSuggest = checkForHashtags(textInfo);
        this.userSuggest = checkForUsers(textInfo);
        this.loadingLink = checkForLinks(textInfo, this.linkPreviews);
        //this.checkForUsers(textInfo);
        //this.checkForHashtags(textInfo);
        //this.checkForLinks(textInfo);
        this.photoCaption[currentIndex] = textInfo; // save to array
      } else { // single post
        let textInfo = this.captionInput;
        this.hashtagSuggest = checkForHashtags(textInfo);
        this.userSuggest = checkForUsers(textInfo);
        this.loadingLink = checkForLinks(textInfo, this.linkPreviews);
        //this.checkForHashtags(textInfo);
        //this.checkForUsers(textInfo);
        //this.checkForLinks(textInfo);
      }
    },
    removeLink() {
      this.loadingLink = false;
      this.$store.commit('helpers/setLinkUrl', undefined);
    },
    removeLocation(){
      this.$store.commit('post/setLocation', { location: '', post_gps: '' });
      this.$store.commit('post/setCounty', { state: '', county: '' });
      this.fccFail = false;
    },
    updateUsername(usernameString) {
      var splitString = this.captionInput.split(' ');
      let lastWord = splitString[splitString.length - 1];
      this.captionInput = this.captionInput.replace(lastWord, '@' + usernameString + ' ');
      this.userSuggest = false;
    },
    updateHashtag(hashtagString) {
      //console.log('selected: ' + hashtagString);
      var splitString = this.captionInput.split(' ');
      let lastWord = splitString[splitString.length - 1];
      this.captionInput = this.captionInput.replace(lastWord, hashtagString + ' ');
      this.hashtagSuggest = false;
    },
    async updateTextBox() {
      let slider = await this.$refs['imageSlider'].swiper;
      let currentIndex = slider.activeIndex;
      //let currentIndex = await slider.getActiveIndex();
      this.sliderIndex = currentIndex;
      this.captionInput = this.photoCaption[currentIndex];
    },
    showVisibility(iconFlag) {
      var icon = globe;
      var visibilityText = globe;

      if (this.$store.state.post.postData['id'] != '') {
        if (iconFlag == 1) {
          return lockClosed;
        } else {
          visibilityText = this.$t("buttons.setbystory");
          return visibilityText;
        }
      } else {
        let visibility = this.$store.state.post.postData['visibility'];
        if (iconFlag == 1) {
          if (visibility == 0) {
            // check for viewers/groups here
            if (this.$store.state.post.postData['viewFollowers'].length > 0 || this.$store.state.post.postData['viewGroup'] != '') {
              icon = people
            } else {
              icon = person;
            }
          } else if (visibility == 1) {
            icon = globe;
          } else if (visibility == 2) {
            icon = people;
          } else if (visibility == 3) {
            icon = bookmarks;
          } 
          
          if (this.$store.state.post.postData['is_premiere']) {
            console.log('Video Premiere');
            icon = bookmarks;
          } 
          return icon;
        } else {
          if (visibility == 0) {
            // check for viewers/groups here
            if (this.$store.state.post.postData['viewFollowers'].length > 0) {
              visibilityText = this.$store.state.post.postData['viewFollowers'].length + ' ' + this.$t("buttons.followers");
            } else if (this.$store.state.post.postData['viewGroup'] != '') {
              visibilityText = this.$t("buttons.group") + ': ' + this.$store.state.post.postData['viewGroup'].group_name;
            } else {
              visibilityText = this.$t("buttons.onlyme");
            }
          } else if (visibility == 1) {
            visibilityText = this.$t("buttons.everyone");
          } else if (visibility == 2) {
            visibilityText = this.$t("buttons.allfollowers");
          } else if (visibility == 3) {
            visibilityText = this.$t("buttons.subscription");
          } 

          if (this.$store.state.post.postData['is_premiere']) {
            visibilityText = "Video Premiere";
          }
          return visibilityText;
        }
      }
    },
    async prevSlide() {
      var slider = await this.$refs['imageSlider'].swiper;
      slider.slidePrev(600);
    },
    async nextSlide() {
      var slider = await this.$refs['imageSlider'].swiper;
      slider.slideNext(600);
    },
    placeholderDisplay() {
      if (this.report) {
        return 'What did you observe?';
      } else {
        if (this.showSlides) {
          return this.$t("placeholder.textbox");
        } else {
          return this.$t("placeholder.textbox2");
        }
      }
    },
    async openChooseStoryModal() {
      let userGroupSetting;
      if(this.usergroup!=''){
        userGroupSetting = this.usergroup;
      }
      const modal = await modalController
        .create({
          component: ChooseStoryModal,
          cssClass: 'modal-custom-class',
          componentProps: {
            title: this.$t("modalhead.story"),
            usergroup: userGroupSetting
          }
        })
      //console.log(this.premiumContent, 'premium content');
      return await modal.present();
    },
    async openAddPlaceModal() {
      const modal = await modalController
        .create({
          component: AddPlaceModal,
          cssClass: 'modal-custom-class',
          componentProps: {
            title: 'Add Location',
            report: this.report
          }
        })
      //console.log(this.premiumContent, 'premium content');
      return await modal.present();
    },
    async openFriendModal() {
      if (this.$store.state.post.postData['id'] == '' && this.$store.state.post.postData['visibility'] != '3') {
        const modal = await modalController
          .create({
            component: FriendModal,
            cssClass: 'modal-custom-class',
            componentProps: {
              title: this.$t("modalhead.canview"),
              type: 'canview'
            }
          })
        await modal.present();
        /* const { role } = await modal.onDidDismiss();
        if (role != undefined) {
          console.log(role,'role');
          if(this.$store.state.post.postData['viewGroup']!=''){
            this.usergroup = this.$store.state.post.postData['viewGroup'];
          }
        }*/
      }
    },
    removeStory() {
      this.$store.commit('post/removeStory');
    },
    checkForMultipleVideos() {
      let totalVideos = 0;
      let singleVideo = true;
      for (var i = 0; i < this.photoFiles.length; i++) {
        if (this.photoType[i] == 2) totalVideos = totalVideos + 1;
      }
      if (totalVideos > 1) {
        singleVideo = false;
      }
      return singleVideo;
    },
    checkForVideo() {
      let totalVideos = 0;
      for (var i = 0; i < this.photoFiles.length; i++) {
        if (this.photoType[i] == 2) totalVideos = totalVideos + 1;
      }
      return totalVideos;
    },
    setPremiere() {
      if (this.$store.state.post.postData['is_premiere'] == true) {
        this.$store.state.post.postData['premiere_date'] = this.defaultPremiereDate;
        //this.$store.state.post.postData['visibility'] = 4;
      } //else {
        //this.$store.state.post.postData['visibility'] = 1; 
      //}
      //console.log(this.$store.state.post.postData['visibility'], 'visibility');
    },
    resetPostData() {
      var showVisibility = '1';
      if (this.profilePrivacy == 1) {
        showVisibility = '2';
      }
      this.$store.commit('post/setPostData', {
        id: '',
        name: '',
        piklock: '0',
        visibility: showVisibility,
        addGroup: '',
        addFollowers: [],
        viewGroup: '',
        viewFollowers: [],
        share_off: '',
        photoFiles: [],
        photoType: [],
        photoCaption: [],
        textPost: '',
        userGroup: [],
        location: ''
      });
    },
    async postNewStory() {
      if (this.checkForMultipleVideos() == false) {
        this.presentTooManyVideos()
        return;
      }
      //this.resetPostData();
      // var validated = this.validateFields();
      if (this.photoFiles.length > 0) {
        this.$store.commit('post/setPhotoFiles', this.photoFiles);
        this.$store.commit('post/setPhotoType', this.photoType);
        this.$store.commit('post/setPhotoCaption', this.photoCaption);
        this.uploading = true;
        this.uploadingText = this.$t("loadmessage.uploading");
      } else if (this.captionInput != '') {
        console.log('uploading text');
      } else {
        // nothing to upload
        console.log('nothing to upload');
        return;
      }

      if (this.usergroup != undefined) {
        //console.log(this.usergroup, 'user group data');
        this.$store.commit('post/setUserGroup', this.usergroup);
      }

      /* console.log('files: ' + this.photoFiles.length);
      console.log('type: ' + this.photoType.length);
      console.log('caption: ' + this.photoCaption.length);
      console.log('link: ' + this.photoLink.length); */
      await this.presentLoading();
      if (isPlatform('cordova')) {
        Insomnia.keepAwake();
      }
      // check if it's new or add to story
      if (this.$store.state.post.postData['id'] == '') {
        console.log('create new story');
        let response = await this.$store.dispatch("post/createStory");
        if (response) {
          if (response['error'] != undefined) {
            if (isPlatform('cordova')) {
              Insomnia.allowSleepAgain();
            }
            console.log('error on create');
            this.loadingIndicator.dismiss();
            this.error = response['error'];
            this.presentAlert();
            //console.log('Error: ' + response['error']);
          } else {
            /* this.loadingIndicator.dismiss();
            this.closeModal();
            this.$router.go(); */
            this.$store.commit('post/setStoryId', response);
            console.log('new story:', this.currentStoryId);
            this.uploadItems();
          }
        }
      } else {
        console.log('update date');
        let response = await this.$store.dispatch("post/updateDate");
        if (response) {
          if (response['error'] != undefined) {
            if (isPlatform('cordova')) {
              Insomnia.allowSleepAgain();
            }
            this.loadingIndicator.dismiss();
            this.error = response['error'];
            this.presentAlert();
          } else {
            //console.log(piklist_id, 'date updated for id');
            this.uploadItems();
            /* this.loadingIndicator.dismiss();
            this.closeModal();
            this.$router.go(); */
          }
        }
      }
    },
    async uploadItems() {
      if (this.photoFiles.length > 0) {
        for (var i = 0; i < this.photoFiles.length; i++) {
          //var filesize = this.fileSize[i];
          if (this.photoFiles.length == 1) { // check in case they put text in before photo
            this.photoCaption[i] = this.captionInput;
          }
          if (this.report) {
            // add hashtags
            this.photoCaption[i] = this.photoCaption[i] + ' #ElectionFraud';
            for (let j = 0; j < this.reporterHashTags.length; j++) {
              this.photoCaption[i] = this.photoCaption[i] + ' #' + this.reporterHashTags[j];
            }
            // add state as a hashtag
            /* if (this.chosenState != "Choose State") {
              let stateName = this.chosenState.replace(/\s/g, '');
              this.photoCaption[i] = this.photoCaption[i] + ' #' + stateName;
            } */
          }
          // var input = this.$refs['fileInput'];
          // console.log(this.fileSize);
          // console.log(this.fileSize[i]);
          var postText = this.$t("loadmessage.posting") + ' ' + (i + 1) + ' of ' + this.photoFiles.length;
          if (this.photoFiles.length < 2) {
            postText = this.$t("loadmessage.posting") + ' ';
          }
          //console.log(filesize, 'file size');
          if (this.photoType[i] == 2) {
            //console.log('very large video, upload in chunks');
            this.uploadingText = postText;
            //this.largeReader = new FileReader();
            this.uploadVideoChunk(0, i, '');
          } else {
            // smaller files can be uploaded at once
            //console.log('photo or small video');
            this.uploadingText = postText;
            let link_url = '';
            let link_text = '';
            let link_image = '';
            let link_video = '';

            if (this.linkPreviews != undefined) {
              link_url = this.linkPreviews.link_url;
              link_text = this.linkPreviews.link_text;
              link_image = this.linkPreviews.link_image;
              link_video = this.linkPreviews.link_video;
            }
            const photoFile = this.photoFiles[i]();
            const storyId = this.currentStoryId;
            console.log('uploading photo', storyId);
            let response = await this.$store.dispatch("post/uploadPhotos", {
              story_id: storyId,
              photo: photoFile,
              type: this.photoType[i],
              caption: this.photoCaption[i],
              total: this.photoFiles.length,
              current: i,
              link_url: link_url,
              link_text: link_text,
              link_image: link_image,
              link_video: link_video
            });
            if (response != undefined) {
              if (response['error'] != undefined) {
                this.loadingIndicator.dismiss();
                this.error = response['error'];
                this.presentAlert();
                //console.log('Error: ' + response['error']);
              }
              // send alert about processing on close do this
              // check if all videos have been processed 
              this.filesUploaded = this.filesUploaded + 1;
              if (this.filesUploaded == this.photoFiles.length) {
                if (isPlatform('cordova')) {
                  Insomnia.allowSleepAgain();
                }
                this.loadingIndicator.dismiss();
                this.$store.commit('helpers/setLinkUrl', undefined);
                let postType = 'feed';
                if (this.report) {
                  postType = 'elections'
                }
                if (this.usergroup != '') {
                  postType = 'groups'
                }
                modalController.dismiss(response, postType);
              }
            }
          }
        }
      } else {
        let link_url = '';
        let link_text = '';
        let link_image = '';
        let link_video = '';
        let link_width = '';
        let link_height = '';

        if (this.linkPreviews != undefined) {
          link_url = this.linkPreviews.link_url;
          link_text = this.linkPreviews.link_text;
          link_image = this.linkPreviews.link_image;
          link_video = this.linkPreviews.link_video;
          link_width = this.linkPreviews.link_width;
          link_height = this.linkPreviews.link_height;
        }
        let textCaption = this.captionInput;
        if (this.report) {
          // add hashtags
          textCaption = textCaption + ' #ElectionFraud';
          for (let i = 0; i < this.reporterHashTags.length; i++) {
            textCaption = textCaption + ' #' + this.reporterHashTags[i];
          }
          // add state as a hashtag
          /* if (this.chosenState != "Choose State") {
            let stateName = this.chosenState.replace(/\s/g, '');
            textCaption = textCaption + ' #' + stateName;
          }*/
        }
        const storyId = this.currentStoryId;
        console.log('text post', storyId);
        let response = await this.$store.dispatch('post/addTextPost', {
          story_id: storyId,
          caption: textCaption,
          link_url: link_url,
          link_text: link_text,
          link_image: link_image,
          link_video: link_video,
          link_width: link_width,
          link_height: link_height
        });
        if (response) {
          if (response['error'] != undefined) {
            if (isPlatform('cordova')) {
              Insomnia.allowSleepAgain();
            }
            this.loadingIndicator.dismiss();
            this.error = response['error'];
            this.presentAlert();
            //console.log('Error: ' + response['error']);
          } else {
            if (isPlatform('cordova')) {
              Insomnia.allowSleepAgain();
            }
            this.loadingIndicator.dismiss();
            this.$store.commit('helpers/setLinkUrl', undefined);
            let postType = 'feed';
            if (this.report) {
              postType = 'elections'
            }
            if (this.usergroup != '') {
              postType = 'groups'
            }

            modalController.dismiss(response, postType);
            if (this.share_link != '') {
              //console.log('shared link');
              window.location = '/home';
              //this.$router.reload('/myprofile');
            }/*else{
                this.$router.go();
              }*/
          }
        }
      }
    },
    async uploadVideoChunk(start, index, fileId) {
      var file = this.photoFiles[index]();
      var next_slice = start + this.slice_size + 1;
      var chunk = file.slice(start, next_slice);
      const storyId = this.currentStoryId;
      //console.log('sending index: ', index);
      //console.log('sending fileId: ', fileId);
      //console.log('chunk', chunk);
      console.log('sending storyId: ', storyId);
      let response = await this.$store.dispatch('post/uploadPartial', {
        story_id: storyId,
        photo: chunk,
        type: this.photoType[index],
        caption: this.photoCaption[index],
        total: this.photoFiles.length,
        current: index,
        file_id: fileId,
        finalize: 'no'
      });
      if (response) {
        if (response['error'] != undefined) {
          if (isPlatform('cordova')) {
            Insomnia.allowSleepAgain();
          }
          this.loadingIndicator.dismiss();
          this.error = response['error'];
          this.presentAlert();
          //console.log('Error: ' + response['error']);
        } else {
          var size_done = start + this.slice_size;
          var percent_done = Math.floor((size_done / file.size) * 100);
          //console.log(size_done, 'size done so far');
          //console.log(next_slice, 'next slide');
          //console.log(file.size, 'file size');
          if (next_slice < file.size) {
            // Update upload progress
            // $( '#dbi-upload-progress' ).html( `Uploading File -  ${percent_done}%` );
            this.uploadingPercent = ' ' + percent_done + '% done';
            this.uploadingProgress = percent_done * .01;
            // More to upload, call function recursively
            this.uploadVideoChunk(next_slice, index, response);
          } else {
            // Update upload progress
            this.uploadingText = this.$t("loadmessage.processing");
            this.uploadingPercent = '';
            this.uploadingProgress = '';
            let finalResponse = await this.$store.dispatch('post/uploadPartial', {
              story_id: storyId,
              photo: chunk,
              type: this.photoType[index],
              caption: this.photoCaption[index],
              total: this.photoFiles.length,
              current: index,
              file_id: fileId,
              banner_file: this.bannerFile,
              finalize: 'yes'
            });
            if (finalResponse != undefined) {
              if (finalResponse['error'] != undefined) {
                this.loadingIndicator.dismiss();
                this.error = finalResponse['error'];
                this.presentAlert();
                //console.log('Error: ' + finalResponse['error']);
              }
              // send alert about processing on close do this
              // check if all videos have been processed 
              this.filesUploaded = this.filesUploaded + 1;
              URL.revokeObjectURL(this.inputFiles[0]); // remove the preview for the video
              if (this.filesUploaded == this.photoFiles.length) {
                if (isPlatform('cordova')) {
                  Insomnia.allowSleepAgain();
                }
                this.loadingIndicator.dismiss();
                this.presentLargeVideoAlertConfirm(finalResponse);
              }
            }
            return;
          }
        }
      }
    },
    async presentLargeVideoAlertConfirm(response) {
      const alert = await alertController
        .create({
          cssClass: 'my-custom-class',
          header: this.$t("alerthead.uploadcomplete"),
          message: this.$t("alertmessage.uploadcomplete"),
          buttons: [
            {
              text: this.$t("buttons.close"),
              handler: () => {
                //this.closeModal();
                this.$store.commit('helpers/setLinkUrl', undefined);
                let postType = 'feed';
                if (this.report) {
                  postType = 'elections'
                }
                if (this.usergroup != '') {
                  postType = 'groups'
                }
                    
                modalController.dismiss(response, postType);
              },
            },

          ],
        });
      return alert.present();
    },
    async presentAlert() {
      const alert = await alertController
        .create({
          cssClass: 'my-custom-class',
          header: this.$t('alerthead.errorupdate'),
          subHeader: this.$t('alertmessage.errorupdate'),
          message: this.error,
          buttons: ['OK'],
        });
      await alert.present();
      const { role } = await alert.onDidDismiss();
      console.log('onDidDismiss resolved with role', role);
    },
    async presentTooManyVideos() {
      const alert = await alertController
        .create({
          cssClass: 'my-custom-class',
          header: this.$t("alerthead.toomanyvideos"),
          message: this.$t("alertmessage.toomanyvideos"),
          buttons: [
            {
              text: this.$t("buttons.close")
            },

          ],
        });
      return alert.present();
    },
    async openVideoPlayerModal(index) {
      const modal = await modalController
        .create({
          component: VideoPlayerModal,
          componentProps: {
            title: this.$t("modalhead.preview"),
            story: null,
            image: null,
            file: this.photoFiles[index]
          }
        })
      /* modal.onDidDismiss().then(() => {
        this.completedPost();
      }); */

      return await modal.present();
    },
    async presentLoading() {
      this.loadingIndicator = await loadingController
        .create({
          cssClass: 'loading-class',
          message: this.$t("loadmessage.posting"),
        });
      await this.loadingIndicator.present();
    },
    showPostButton() {
      let buttonLabel = this.$t("buttons.post")
      if (this.report) {
        buttonLabel = "Report Issue";
      }
      return buttonLabel;
    },
    openPopover(e) {
      this.event = e;
      this.popoverOpen = true;
    },
    addHashTag(tag) {
      let foundTag = -1;
      for (let i = 0; i < this.reporterHashTags.length; i++) {
        if (this.reporterHashTags[i] == tag) {
          foundTag = i;
        }
      }
      if (foundTag == -1) {
        this.reporterHashTags.push(tag);
      } else {
        this.reporterHashTags.splice(foundTag, 1);
      }
    },
    checkHashTags(tag) {
      let foundTag = this.reporterHashTags.find(function (element) {
        return element == tag;
      });
      if (foundTag == undefined) {
        return false;
      } else {
        return true;
      }

    },
    hashTagsColor(tag) {
      let foundTag = this.reporterHashTags.find(function (element) {
        return element == tag;
      });
      if (foundTag == undefined) {
        return 'dark';
      } else {
        return 'primary';
      }

    },
    async getStateCounty() {
      let response = await this.$store.dispatch("post/lastLocation");
      this.fccFail = false;
        
      if (response.error != undefined) {
        console.log(response.error, 'error');
      }else{
        if(response.post_address!=undefined && response.post_gps!=undefined){
          this.$store.commit('post/setLocation', { location: response.post_address, post_gps: response.post_gps });
          const coords = response.post_gps.split(",");
          let responseFcc = await this.$store.dispatch('post/findStateCounty', { lat: coords[0], long: coords[1] });
          if (responseFcc != undefined) {
            if (responseFcc['error'] != undefined) {
              this.fccFail = true;
            }
          }
        }
      }
    },
    dataURLToBlob(dataUrl) {
      const byteString = atob(dataUrl.split(",")[1]); // Decode base64
      const mimeString = dataUrl.split(",")[0].split(":")[1].split(";")[0]; // Extract MIME type

      const byteArray = new Uint8Array(byteString.length);
      for (let i = 0; i < byteString.length; i++) {
        byteArray[i] = byteString.charCodeAt(i);
      }

      return new Blob([byteArray], { type: mimeString });
    }
    /* async displayStates() {
      let stateData = [];
      for (let i = 0; i < this.states.length; i++) {
        stateData[i] =
        {
          text: this.states[i],
          data: {
            action: this.states[i],
          }
        }
      }
      stateData[this.states.length] = {
        text: 'Cancel',
        role: 'cancel',
        data: {
          action: 'cancel',
        },
      };

      const actionSheet = await actionSheetController.create({
        header: 'Choose State',
        buttons: stateData,
      });

      await actionSheet.present();
      let dismissed = await actionSheet.onDidDismiss();
      if (dismissed != undefined) {
        if (dismissed.data.action != 'cancel') {
          this.chosenState = dismissed.data.action;
        }
      }
    }*/
  },
  computed: {
    usernames() {
      if (this.$store.state.helpers.usernameData[0] != undefined) {
        //console.log(this.$store.state.helpers.usernameData[0]['All Users']);
        return this.$store.state.helpers.usernameData[0]['All Users'];
      } else {
        return [];
      }
    },
    hashtags() {
      if (this.$store.state.helpers.hashtagData[0] != undefined) {
        //console.log(this.$store.state.helpers.hashtagData[0]['Hash Tags']);
        return this.$store.state.helpers.hashtagData[0]['Hash Tags'];
      } else {
        return [];
      }
    },
    states() {
      return this.$store.state.helpers.states;
    },
    linkPreviews() {
      if (this.$store.state.helpers.linkData != undefined) {
        //console.log(this.$store.state.helpers.linkData, 'computed');
        return this.$store.state.helpers.linkData;
      } else {
        //console.log('cleaned out');
        return undefined;
      }
    },
    profilePic() {
      return this.$store.state.profile.pic;
    },
    usergroup() {
      if(this.$store.state.post.postData['viewGroup']!=undefined){
        return this.$store.state.post.postData['viewGroup'];
      }else{
        return '';
      }
    },
    profileName() {
      if (this.$store.state.profile.fullname == '') {
        return '@' + this.$store.state.profile.username;
      } else {
        return this.$store.state.profile.fullname;
      }

    },
    profilePrivacy() {
      return this.$store.state.profile.private;
    },
    showHashtagInfo() {
      let data = {
        'Ballots':	'Any anomaly pertaining to ballots including but not limited to paper specifications, marker specifications, printers, lot control, candidate listings, or security.',
        'BallotTrafficking':	'Information pertaining to ballot factories, ballot distribution centers, mules, and the organizations involved.',
        'Certification':	'Machine certification issues pertaining federal, state, and local requirements compliance as well as pre-election logic and accuracy testing issues.',
        'ChainofCustody':	'Any breaks in the digital and/or physical election record chain of custody',
        'DestructionofRecords':	'Any incidents involving attempted or actual destruction of digital and/or physical election records',
        'DropBoxes':	'Anomalies pertaining to the use of drop boxes including but not limited to surveillance records availability, multiple ballot drops, location anomalies, and pickup/dropoff anomalies.',
        'ElectionFraud':	'Any evidence of illegal interference with the process of conducting an election.',
        'FinancialTransactions':	'Any evidence of suspicious financial relationships between individuals or organizations associated with election fraud.',
        'MachinesDown':	'Any incidents featuring machine errors',
        'MachinesOnline':	'Any evidence that suggests that election systems are connected to external systems',
        'Obstruction':	'Any attempts to interfere with the lawful oversight of election processes',
        'PollBooks':	'Any anomalies specific to poll books',
        'Racketeering':	'Any indications of a pattern of illegal activities conducted as part of an organized effort.',
        'SpecialVotingCenters':	'Any indications of voting centers not disclosed to the general public.',
        'ViolationofProcedures':	'Any evidence of failure to comply with official election procedures',
        'ViolationofLaw':	'Any evidence of failure to comply with statutes',
        'VoterHistory':	'Any anomalies specific to whether or not an individual actually voted as well as their voting method.',
        'VoterRolls':	'Any anomalies specific to whether or not an individual listed as eligible to vote is asctually legally eligible to vote',
        'VoteTally': 'Any evidence of vote tally anomalies',
        'VotingSystems': 'Any example of machines which tally votes not being subject to oversight by general public or displaying behavior that is not compliant with government specifications.'
      }
      return data;
    },
    currentStoryId() {
      return this.$store.state.post.postData['id']; // Computed property to get the current storyId
    },
    defaultPremiereDate() {
      // Get the current time in the user's timezone
      const now = dayjs().tz(dayjs.tz.guess());
      const premiereDate = now.add(1, 'hour').startOf('hour'); // Add 1 hour and set minutes to 0
      return premiereDate.format('YYYY-MM-DDTHH:mm'); // Format for `ion-datetime`
    },
    minuteValues() {
      return Array.from({ length: 12 }, (_, i) => i * 5).join(','); // Generate "0,5,10,...,55"
    },
  },
});
</script>
<style scoped>
.swiper-pagination {
  background-color: rgba(0, 0, 0, 0.3);
  bottom: 0px;
  padding: 3px;
  color: white;
}

.swiper-button-prev-cs-2,
.swiper-button-next-cs-2 {
  position: absolute;
  background-image: none;
  margin-left: 10px;
  top: 45%;
  background-color: rgba(100, 100, 100, .4);
  z-index: 9999;
  height: 50px;
  width: 50px;
  padding-top: 10px;
  border-radius: 5px;
  color: white;
}

.swiper-button-next-cs-2 {
  right: 0;
  margin-right: 10px;
}

.swiper-pagination-bullet {
  background-color: lightgray;
}

.swiper-pagination-bullet-active {
  background-color: white;
}

.swiper-container {
  width: 100%;
  height: auto;
}

.post-grid {
  --ion-grid-padding: 0px;
}

.centered-datetime {
  display: flex;
  justify-content: center;
  align-items: center;
}

.banner-preview-container {
  display: flex;
  flex-direction: column; /* Stack the text and image vertically */
  align-items: center; /* Center horizontally */
  justify-content: center; /* Center vertically */
  width: 100%;
  padding: 10px 15px;
}

.banner-preview-image {
  height: 100px;
  margin: 0 auto; /* Center horizontally */
  object-fit: contain; /* Ensure the image fits within the height */
}

.horizontal-scroll-container {
  display: flex;
  overflow-x: auto;
  padding: 10px;
}

.photo-item {
  flex: 0 0 auto;
  margin-right: 10px;
  height: 100px;
}

.photo-item.selected {
  border: 2px solid #007bff; /* Highlight with a blue border */
  border-radius: 5px;
}
</style>
